// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"37":"08a720ab","59":"e7835dd8","563":"1deafa37"}[chunkId] + ".js";
};